<script>
import plans, { AllPlans } from '@/plans';
import { props } from '@/plans/mx/shopping-cart';
import { defFilter } from '../plans';
import { mapGetters } from 'vuex';

export default {
  props: {
    ...props,
    filter: {
      type: Function,
      default: defFilter,
    },
    filterKeys: {
      type: Array,
      default: () => [],
    },
  },
  computed:{
    ...mapGetters(['pastPlans', 'hasZoomDevice']),
  },
  render(h) {
    let orderPlans = plans, filterKeys = this.filterKeys || [];
    if (this.pastPlans?.length > 0) {
      orderPlans = AllPlans;
    }
    if (this.hasZoomDevice) {
      filterKeys = [
        ...filterKeys.filter(key => !key.startsWith('ZOOM_DEVICE')),
        'ZOOM_DEVICE',
      ]
    }
    return h(
      'div',
      {},
      this.filter(orderPlans, filterKeys).map((x) =>
        h(x.components?.cart, {
          ...this.$attrs,
          props: { ...this.$props, $pkg: x },
          on: {
            ...this.$listeners,
          },
        }),
      ),
    );
  },
};
</script>


